module.exports = __webpack_public_path__ + "static/media/icon_check.91649a93.svg";